/**
 * Constantes y helpers compartidos para páginas de Fase 15 · Aceptación G-02.
 */

export const PRODUCTOS = [
    { code: "P-GAR", label: "Fideicomiso de Garantía" },
    { code: "P-AFP", label: "Administración / Afectación / Pagos" },
    { code: "P-ESC", label: "Escrow" },
    { code: "P-INV", label: "Inversión" },
    { code: "P-PLA", label: "Planeación Patrimonial" },
    { code: "P-EMI", label: "Emisión Bursátil (CNBV)" },
];

export const PRODUCTO_LABEL = Object.fromEntries(
    PRODUCTOS.map((p) => [p.code, p.label]),
);

export const PASOS = [
    "Recepción",
    "Precalificación",
    "Análisis PLD",
    "Análisis Jurídico",
    "Análisis Riesgos",
    "Dictamen Comité (F-09)",
    "Resolución final",
];

export const COMPLEJIDADES = [
    { value: "estandar", label: "Estándar · 10 días hábiles" },
    { value: "compleja", label: "Compleja · 20 días hábiles" },
];

export const ORIGENES = [
    { value: "lead_publico", label: "Lead público (landing)" },
    { value: "referencia_directa", label: "Referencia directa" },
    { value: "sustitucion_fiduciaria", label: "Sustitución fiduciaria" },
    { value: "otro", label: "Otro" },
];

export const ESTADO_LABEL = {
    en_proceso: "En proceso",
    aprobado: "Aprobado",
    aprobado_con_condiciones: "Aprobado con condiciones",
    rechazado: "Rechazado",
    caducado: "Caducado",
    declinado_solicitante: "Declinado por solicitante",
};

export const ESTADO_BADGE = {
    en_proceso: "bg-blue-50 text-blue-800 border-blue-200",
    aprobado: "bg-emerald-50 text-emerald-800 border-emerald-200",
    aprobado_con_condiciones: "bg-amber-50 text-amber-800 border-amber-200",
    rechazado: "bg-red-50 text-red-800 border-red-200",
    caducado: "bg-gray-100 text-gray-700 border-gray-200",
    declinado_solicitante: "bg-stone-100 text-stone-700 border-stone-200",
};

export const CALIF_BADGE = {
    A: "bg-emerald-100 text-emerald-800 border-emerald-300",
    B: "bg-amber-100 text-amber-800 border-amber-300",
    C: "bg-red-100 text-red-800 border-red-300",
};

export const DIM_BADGE = {
    favorable: "bg-emerald-50 text-emerald-700 border-emerald-200",
    con_observaciones: "bg-amber-50 text-amber-700 border-amber-200",
    desfavorable: "bg-red-50 text-red-700 border-red-200",
};

export const DIMENSIONES_F09 = [
    { key: "legal", label: "Jurídica" },
    { key: "financiera", label: "Financiera" },
    { key: "operativa", label: "Operativa" },
    { key: "riesgos", label: "Riesgos" },
    { key: "pld", label: "PLD / Prevención" },
    { key: "estrategica", label: "Estratégica / Comercial" },
];

export const SECCIONES_F08 = [
    { key: "A_constitutivo", label: "A · Documentación constitutiva" },
    { key: "B_kyc_pld", label: "B · KYC / PLD" },
    { key: "C_patrimonio", label: "C · Patrimonio y aportaciones" },
    { key: "D_gobierno", label: "D · Gobierno fiduciario" },
    { key: "E_fiscal", label: "E · Fiscal" },
];

/** Formato de moneda MXN. */
export const fmtMXN = (n) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    return new Intl.NumberFormat("es-MX", {
        style: "currency", currency: "MXN", maximumFractionDigits: 0,
    }).format(n);
};

/** Semáforo SLA. Devuelve color de badge. */
export function slaColor(dias_en_proceso, dentro_de_sla, sla_dias) {
    if (!dentro_de_sla) return "bg-red-100 text-red-800 border-red-300";
    const restantes = (sla_dias || 10) - (dias_en_proceso || 0);
    if (restantes <= 3) return "bg-amber-100 text-amber-800 border-amber-300";
    return "bg-emerald-100 text-emerald-800 border-emerald-300";
}

/** Formatear ISO date → DD/MM/YYYY. */
export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("es-MX", {
            day: "2-digit", month: "2-digit", year: "numeric",
        });
    } catch { return iso; }
}

export function diasRestantes(iso_fecha) {
    if (!iso_fecha) return null;
    try {
        const d = new Date(iso_fecha);
        const now = new Date();
        return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
    } catch { return null; }
}
